import findInObject from '../findInObject'

/**
 * externalLinkFilter
 *
 * This is a content filter function. It receives content,
 * obj, and originalMatch from the shortcodeParser.
 *
 * The purpose of this function is to replace "externalLink" shortcodes with
 * external link markup.
 *
 * externalLink requires three properties, shortcode, content, link.
 *
 * {{ shortcode: "externalLink", content: "Click Here", link: "https://example.com" }}
 *
 * @param {string} content - The full chunk of content
 * @param {object} obj - The shortcode as a JS object
 * @param {string} originalMatch - The original match, useful for replacing the shortcode
 *
 * @returns {string} content
 */
const externalLinkFilter = (content, obj, originalMatch) => {
  const objType = findInObject('shortcode', obj)

  if (objType === 'externalLink') {
    const innerHTML = `${findInObject('content', obj)}`
    const link = `${findInObject('link', obj)}`
    const updatedContent = `<a href="${link}" rel="noopenner noreferrer" target="_blank">${innerHTML}</a>`
    content = content.replace(originalMatch, updatedContent)
  }

  return content
}

export default externalLinkFilter
